/**
 * applicationDatabaseRelation模块接口列表
 */
import $http from "../utils/http"; // 导入http中创建的axios实例

const applicationDatabaseRelation = {
  // 增加applicationDatabaseRelation关联表
  createApplicationDatabaseRelation(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationDatabaseRelation/create`,
      params
    );
  },
  // 删除applicationDatabaseRelation关联表
  deleteApplicationDatabaseRelation(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationDatabaseRelation/deleteByApplicationIdAndDatabaseId`,
      params
    );
  },
  // 根据应用ID和实例ID查询权重
  selectWeightByApplicationIdAndDatabaseId(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationDatabaseRelation/selectWeightByApplicationIdAndDatabaseId`,
      params
    );
  },
  // 编辑实例权重
  updateInstanceWeight(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationDatabaseRelation/updateInstanceWeight`,
      params
    );
  },
  updateDatabaseWeight(params) {
    return $http.post(
      `${global.API_URL}/sme/applicationDatabaseRelation/updateDatabaseWeight`,
      params
    );
  }
};

export default applicationDatabaseRelation;



// WEBPACK FOOTER //
// ./src/api/applicationDatabaseRelation.js